"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.LaPosteEn4Entity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var fields_1 = require("../../../fields");
var slices_1 = require("../../../slices");
var page_factory_1 = require("./page-factory");
var disclaimerSlice = function (data, logger) {
    var _a;
    var description = fields_1.toRichText((_a = data.primary) === null || _a === void 0 ? void 0 : _a.description, logger);
    if (!description) {
        return undefined;
    }
    return utils_1.compact({
        type: types_1.LaPosteEn4SliceType.Disclaimer,
        description: description
    });
};
var footnotesSlice = function (data) {
    var _a, _b;
    if (!((_a = data.items) === null || _a === void 0 ? void 0 : _a.length)) {
        return undefined;
    }
    return utils_1.compact({
        type: types_1.LaPosteEn4SliceType.Footnotes,
        notes: (_b = data.items) === null || _b === void 0 ? void 0 : _b.map(function (note) {
            var reference = fields_1.toText(note.char);
            var description = fields_1.toText(note.description);
            if (!reference || !description) {
                return undefined;
            }
            return {
                reference: reference,
                description: description
            };
        }).filter(Boolean)
    });
};
var proofCategorySlice = function (data, logger) {
    var _a, _b, _c;
    var title = fields_1.toText((_a = data.primary) === null || _a === void 0 ? void 0 : _a.title);
    var theme = fields_1.toText((_b = data.primary) === null || _b === void 0 ? void 0 : _b.theme);
    if (!title || !theme || !((_c = data.items) === null || _c === void 0 ? void 0 : _c.length)) {
        return undefined;
    }
    return utils_1.compact({
        type: types_1.LaPosteEn4SliceType.ProofCategory,
        title: title,
        theme: theme,
        items: data.items
            .map(function (item) {
            var icon = fields_1.toText(item.icon);
            var title = fields_1.toText(item.title);
            var description = fields_1.toRichText(item.description, logger);
            if (!icon || !title || !description) {
                return undefined;
            }
            return utils_1.compact({
                icon: fields_1.toText(item.icon),
                title: fields_1.toText(item.title),
                description: fields_1.toRichText(item.description, logger),
                ctaLabel: fields_1.toText(item.ctaLabel),
                ctaLink: fields_1.toLink(item.ctaLink, logger)
            });
        })
            .filter(Boolean)
    });
};
var headerSlice = function (data, logger) {
    var _a, _b, _c, _d;
    var image = fields_1.toImage((_a = data.primary) === null || _a === void 0 ? void 0 : _a.image, logger);
    var description = fields_1.toRichText((_b = data.primary) === null || _b === void 0 ? void 0 : _b.description, logger);
    if (!image || !description) {
        return undefined;
    }
    return utils_1.compact({
        type: types_1.LaPosteEn4SliceType.Header,
        image: image,
        description: description,
        ctaLabel: fields_1.toText((_c = data.primary) === null || _c === void 0 ? void 0 : _c.ctaLabel),
        ctaLink: fields_1.toLink((_d = data.primary) === null || _d === void 0 ? void 0 : _d.ctaLink, logger)
    });
};
exports.LaPosteEn4Entity = page_factory_1.pageFactory(types_1.PageType.LA_POSTE_EN_4, function (prismicDoc, normalizedPage, logger) {
    var _a;
    return utils_1.compact(__assign(__assign({}, normalizedPage), { body: slices_1.processSlices({
            header: headerSlice,
            proof_category: proofCategorySlice,
            disclaimer: disclaimerSlice,
            footnotes: footnotesSlice
        }, (_a = prismicDoc.data) === null || _a === void 0 ? void 0 : _a.body_slices, logger) }));
});
//# sourceMappingURL=la-poste-en-4.js.map